module.exports = __webpack_public_path__ + "static/img/top.46b018f6.jpg";